module.exports = __webpack_public_path__ + "img/graph-widget-illustration-1.a2fdbe28.png";